import { Zap, Building2, Droplets, Wifi, Receipt } from "lucide-react";
import { toast } from "sonner";

export const BILL_TYPES = [
  { value: "rent", label: "Office rent", icon: Building2, tone: "bg-amber-50 text-amber-800 ring-amber-200" },
  { value: "electricity", label: "Electricity", icon: Zap, tone: "bg-yellow-50 text-yellow-800 ring-yellow-200" },
  { value: "water", label: "Water", icon: Droplets, tone: "bg-sky-50 text-sky-800 ring-sky-200" },
  { value: "internet", label: "Internet & phone", icon: Wifi, tone: "bg-violet-50 text-violet-800 ring-violet-200" },
  { value: "other", label: "Other bill", icon: Receipt, tone: "bg-slate-50 text-slate-700 ring-slate-200" },
];
export const typeMeta = (t) => BILL_TYPES.find((x) => x.value === t) || BILL_TYPES[4];
export const onErr = (e) => toast.error(e?.response?.data?.detail || "Request failed");


export const FREQ_LABEL = { monthly: "monthly", quarterly: "every 3 months", half_yearly: "every 6 months", yearly: "yearly" };
export const freqLabel = (b) => (b.frequency === "custom" ? `every ${b.interval_months} month${b.interval_months === 1 ? "" : "s"}` : FREQ_LABEL[b.frequency] || b.frequency);
export const TYPE_COLORS = { rent: "#B45309", electricity: "#CA8A04", water: "#0284C7", internet: "#7C3AED", other: "#64748B" };
